import React from 'react'
import { Container } from 'react-bootstrap'

function TermsScreen() {
  return (
    <Container className="py-4">
      <h2 className="ws-section-title">Terms of Service</h2>
      <p className="ws-muted">
        These Terms govern your use of WigsNStuff. By accessing our site or placing an order,
        you agree to these Terms. We may update them periodically; continued use means you accept
        the latest version.
      </p>
      <h5>Orders and Payment</h5>
      <p className="ws-muted">
        All orders are subject to availability and confirmation of the order price. Prices and
        currencies are displayed per product. We reserve the right to cancel or refuse any order.
      </p>
      <h5>Shipping and Returns</h5>
      <p className="ws-muted">
        Estimated delivery times are provided at checkout. For hygiene reasons, certain items may
        not be eligible for return once opened or worn. Please review our Returns policy before
        purchasing.
      </p>
      <h5>Use of Content</h5>
      <p className="ws-muted">
        All content, including images and text, is the property of WigsNStuff and may not be used
        without written permission.
      </p>
      <h5>Contact</h5>
      <p className="ws-muted">
        Questions about these Terms? Reach us via the Contact page.
      </p>
    </Container>
  )
}

export default TermsScreen


